<template>
  <div class="document">
    <div class="card-container">
      <div class="card-title-container">
        <div class="columns is-mobile is-gapless fullwidth marginless">
          <div class="column">
            <div class="column-container is-pulled-left">
              <div class="block">
                <div>
                  <span style="font-size:20px">
                    {{ student.firstName }}
                    {{ student.lastName }}
                  </span>
                  <span class="is-italic id has-text-grey">
                    ({{ student.stateStudentId }})
                  </span>
                </div>
                <div class="has-text-weight-bold">
                  {{ student.street1}},
                  <span v-if="student.street2">
                    {{student.street2}},
                  </span>
                </div>
                <div class="has-text-weight-bold">
                  {{ student.city }}, {{ student.stateCode }} {{ student.zip }}
                </div>
              </div>
            </div>
          </div>
          <div class="column has-border">
            <div class="column-container">
              <div class="block ">
                <div>
                  <div>
                    <span
                      class="has-text-weight-bold"
                      style="font-size:17px"
                    >
                      {{ locationInfo('districtName',student) }}
                    </span>
                    <span class="is-size-6 has-text-grey is-italic">
                      ({{student.districtCode}})
                    </span>
                  </div>
                  <div>
                    <span
                      class="has-text-weight-bold"
                      style="font-size:17px"
                    >
                      {{ locationInfo('schoolName',student) }}
                    </span>
                    <span class="is-size-6 has-text-grey is-italic">
                      ({{student.schoolCode }})
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column has-border">
            <div class="columns student-demographic--columns is-mobile is-variable is-1">
              <div class="column flex-direction--column student-demographic--headers">
                <div class="has-text-grey">
                  {{ getFieldLabel(`PER:${personTypeForLabels}:DIRECTMATCH:DATE_OF_BIRTH`) }}:
                </div>
                <div class="has-text-grey">
                  {{ getFieldLabel(`PER:${personTypeForLabels}:DIRECTMATCH:GENDER_CODE`) }}:
                </div>
                <div class="has-text-grey">
                  {{ getFieldLabel(`PER:${personTypeForLabels}:DIRECTMATCH:GRADE_CODE`) }}:
                </div>
              </div>
              <div
                class="column
                  student-demographic--details
                  flex-direction--column
                  has-text-weight-bold"
                style="font-size:17px"
              >
                <div>
                  {{ student.dateOfBirth }}
                </div>
                <div v-if="student.genderCode !== '*'">
                  {{ findGender(student.genderCode) }}
                </div>
                <div v-else>
                  {{ student.genderCode }}
                </div>
                <div>
                  <span v-if="student.gradeCode">
                    {{ student.gradeCode }}
                  </span>
                  <span v-else>
                    &nbsp;
                  </span>
                </div>
              </div>
            </div>
          </div>
            <div class="column has-border">
              <div class="columns student-demographic--columns is-mobile is-variable is-1">
                <div class="column flex-direction--column student-demographic--headers">
                  <div class="has-text-grey">
                    Person Type:
                  </div>
                </div>
                <div
                  class="column
                    student-demographic--details
                    flex-direction--column
                    has-text-weight-bold"
                  style="font-size:17px"
                >
                  <div v-if="student.personType">
                    {{ findPersonType(student.personType) }}
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div
          v-if="personTypeAccess"
          class="column-icons"
          :class="{ 'has-border': !isEditing }"
        >
          <div class="card-title-icon icon">
            <font-awesome-icon
              v-if="!isEditing"
              :icon="['fas', 'edit']"
              class="has-text-primary lg"
              @click="toggleEdit"
            />
          </div>
        </div>
      </div>
      <div>
        <div class="table-container">
          <div class="match-type-header is-flex has-text-weight-bold has-text-grey-dark">
            Manual Match Type
          </div>
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>
                  Eligibility Type
                </th>
                <th>
                  Start Date
                </th>
                <th>
                  End Date
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="loadingMatches">
              <tr>
                <td
                  style="text-align: center"
                  colspan="100%"
                >
                  <es-loader style="margin: 3rem"/>
                </td>
              </tr>
            </tbody>
            <template v-else>
              <es-manual-match-edit
                v-for="(match, index) in manualMatches"
                :key="`match-${index}`"
                :availablePrograms="unselectedPrograms"
                :isEditing="isEditing"
                :match="match"
                :schoolStartDate="schoolStartDate"
                :schoolEndDate="schoolEndDate"
                :programTypes="programTypes"
                :hasErrors="hasErrors"
                @deleteNewProgram="deleteNewProgram(index)"
              />
            </template>
          </table>
          <div class="is-flex flex-direction--column">
            <div v-if="isEditing">
              <a
                v-if="this.manualMatches.length === 0 ||
                  this.unselectedPrograms.length &&
                  this.manualMatches[this.manualMatches.length - 1].studentProgram.programCode"
                class="new-program is-pulled-left"
                @click="addNewProgram"
              >
                + Add A New Program
              </a>
              <span
                v-else
                style="color: #999"
                class="is-pulled-left"
              >
                + Add A New Program
              </span>
            </div>
            <es-form-actions v-if="isEditing">
              <template #form-actions>
                <div class="bottom-content">
                  <ul>
                    <li class="cancel">
                      <div class="list-content">
                        <a v-if="loadingApi">
                          Cancel
                        </a>
                        <a
                          v-else
                          @click="refreshMatches"
                        >
                          Cancel
                        </a>
                      </div>
                    </li>
                    <li>
                      <div class="list-content">
                        <button
                          :disabled="loadingApi"
                          class="button is-primary"
                          @click.stop.prevent="formValidation"
                        >
                          Update
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
            </es-form-actions>
          </div>
        </div>
        <div class="table-container">
          <div
            class="match-type-header
              is-flex
              has-text-weight-bold
              has-text-grey-dark"
            >
              All Other Match Types
            </div>
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>
                  Eligibility Type
                </th>
                <th>
                  Identified Date
                </th>
                <th>
                  Match Source
                </th>
                <th>
                  Location Info
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class= "border--hidden"
                v-for="(program,index) in otherMatches"
                :key="index"
              >
                <td class="one-fourth-width has-text-weight-bold">
                  {{ convertProrgamCode(program.studentProgram.programCode) }}
                </td>
                <td class="one-fourth-width">
                  {{
                    program.studentProgram.entryDate | formatDateMMDDYYYY('-')
                  }}
                </td>
                <td class="one-fourth-width">
                  {{ convertMatchType(program.matchTypeId) }}
                </td>
                <td class="one-fourth-width">
                  <div class="is-flex flex-direction--column">
                    <div class="is-flex">
                      <router-link
                        :to="{
                          name: 'DmDistrictInfoDetails',
                          params: { code: program.studentProgram.districtCode },
                        }"
                        class="has-text-weight-bold has-text-primary"
                        style="font-size:14px"
                      >
                        {{
                          program.district === null
                            ? locationInfo('districtName', program.studentProgram)
                            : program.district.location.name
                        }}
                      </router-link>
                      <span class="padding-left--small has-text-grey">
                        ({{ program.studentProgram.districtCode }})
                      </span>
                    </div>
                    <div class="is-flex">
                      <router-link
                        :to="{
                          name: 'DmSchoolInfoDetails',
                          params: {
                            districtCode: program.studentProgram.districtCode,
                            schoolCode: program.studentProgram.schoolCode,
                          },
                        }"
                        class="is-italic"
                      >
                        {{
                          program.school === null
                            ? locationInfo('schoolName', program.studentProgram)
                            : program.school.location.name
                        }}
                      </router-link>
                      <span class="padding-left--small has-text-grey">
                        ({{ program.studentProgram.schoolCode }})
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationCircle, faEdit } from '@fortawesome/pro-solid-svg-icons';
import axios from 'axios';
import moment from 'moment';
import EsFormActions from '@/components/EsFormActions.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsManualMatchEdit from '@/components/EsManualMatchEdit.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';
import DateUtils from '@/mixins/DateUtils';
import FieldLabels from '@/mixins/FieldLabels';

library.add(
  faExclamationCircle,
  faEdit,
);

export default {
  mixins: [
    BreadcrumbsManager,
    NotificationManager,
    FieldLabels,
    DateUtils,
  ],
  components: {
    EsFormActions,
    EsLoader,
    EsManualMatchEdit,
  },
  props: {
    loadingErrorParent: {
      type: Boolean,
    },
    personTypeAccess: {
      type: Boolean,
    },
    personNotFoundError: {
      type: Boolean,
    },
    student: {
      type: Object,
    },
  },
  data: () => ({
    submissionSpecs: [],
    isEditing: false,
    loading: false,
    loadingError: false,
    loadingApi: false,
    loadingMatches: false,
    manualProgramTypes: [],
    matches: [],
    matchResults: [],
    messages: null,
    programTypes: [],
    hasErrors: false,
    school: [],
    locations: [],
    userPersonTypes: null,
    userPersonTypesCodes: null,
  }),
  created() {
    this.onLoad();
    this.userPersonTypes = this.$store.state.user.userPersonTypes
      .map(item => item.personType).filter(a => a.status === true);
    this.userPersonTypesCodes = this.userPersonTypes
      .map(item => item.code);
  },
  mounted() {
    this.setBreadcrumb([
      { text: 'Home', to: { name: 'directMatch' } },
      { text: 'Match Options', to: {} },
    ]);
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
      'getProperty',
    ]),
    ...mapGetters('lookups', [
      'activeGenders',
      'activeMatchTypes',
      'activePersonTypesForDirectMatch',
      'defaultPersonType',
    ]),
    manualMatches() {
      const matches = this.programMatches
        .filter(match => match.matchTypeId === this.manualMatchTypeId);
      return matches;
    },
    dmPersonTypeMatching() {
      return JSON.parse(this.getProperty('MATCHING_FEATURES-FEATURE_DM_PERSONTYPE_MATCHING'));
    },
    subSpecsArray() {
      return [].concat(...this.submissionSpecs);
    },
    enabledPersonTypes() {
      if (this.subSpecsArray) {
        return this.subSpecsArray.filter(d => d.purpose === 'DMATCH' && d.enabled === true)
          .map(p => p.personType.code);
      } return null;
    },
    otherMatches() {
      return this.programMatches
        .filter(match => match.matchTypeId !== this.manualMatchTypeId);
    },
    personTypeForLabels() {
      if (this.userPersonTypesCodes.includes(this.defaultPersonType)) {
        return this.defaultPersonType;
      } return this.userPersonTypesCodes[0];
    },
    programMatches() {
      return this.matches.filter(match => match.studentProgram);
    },
    selectedPrograms() {
      return this.programTypes
        .filter(program => this.programMatches
          .some(match => match.studentProgram.programCode === program.code));
    },
    currentSchoolYear() {
      return this.properties['RULE-CURRENT_SCHOOL_YEAR'];
    },
    manualMatchTypeId() {
      return this.activeMatchTypes.find(matchType => matchType.code === 'MANL').id;
    },
    schoolStartDate() {
      const startMonthDay = this.properties['RULE-YEAR_START_MONTH_DAY'];
      return `${startMonthDay}/${(this.currentSchoolYear - 1)}`;
    },
    schoolEndDate() {
      const startMonthDay = this.properties['RULE-YEAR_START_MONTH_DAY'];
      return `${startMonthDay}/${(this.currentSchoolYear)}`;
    },
    today() {
      const d = new Date();
      return [d.getFullYear(), (`0${d.getMonth() + 1}`).slice(-2), (`0${d.getDate()}`).slice(-2)].join('-');
    },
    unselectedPrograms() {
      return this.manualProgramTypes
        .filter(manualProgram => !this.programMatches
          .some(match => match.studentProgram.programCode === manualProgram.program.code));
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadGenders',
      'loadMatchTypes',
      'loadPersonTypes',
    ]),
    ...mapActions([
      'getSchool',
    ]),
    addNewProgram() {
      this.matches.push(
        {
          isNewMatch: true,
          matchTypeId: this.manualMatchTypeId,
          matchReason: '',
          matchDate: this.today,
          schoolYear: this.currentSchoolYear,
          districtCode: this.student.districtCode,
          schoolCode: this.student.schoolCode,
          studentProgram: {
            programCode: '',
            districtCode: this.student.districtCode,
            schoolCode: this.student.schoolCode,
            gradeCode: this.student.gradeCode,
            sourceCode: this.student.sourceCode,
            entryDate: this.today,
            schoolYear: this.currentSchoolYear,
          },
        },
      );
    },
    deleteNewProgram(index) {
      const programToDelete = this.manualMatches[index].studentProgram.programCode;
      this.matches.splice(this.matches
        .findIndex(match => programToDelete === match.studentProgram.programCode), 1);
    },
    async refreshMatches() {
      try {
        this.isEditing = false;
        this.loadingMatches = true;
        this.matches = [];
        this.resetErrors();
        const res = await this.getMatchResults();
        this.matches = res.data.data.sort((a, b) => a.id - b.id);
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.loadingMatches = false;
      }
    },
    convertMatchType(id) {
      return this.activeMatchTypes.find(matchType => id === matchType.id).description;
    },
    convertProrgamCode(programCode) {
      return this.programTypes.find(program => programCode === program.code).description;
    },
    findGender(genderCode) {
      return this.activeGenders.find(gender => gender.code === genderCode).description;
    },
    findPersonType(personTypeCode) {
      if (this.activePersonTypesForDirectMatch.length) {
        return this.activePersonTypesForDirectMatch.find(p => p.code === personTypeCode).name;
      }
      return null;
    },
    // TODO: Move form validation into es-manual-match-edit component.
    async formValidation() {
      let errors = 0;
      this.messages = [];
      this.manualMatches.forEach((item) => {
        const { programCode, entryDate, exitDate } = item.studentProgram;
        if (!programCode || programCode === '') {
          errors += 1;
        } else if (entryDate === null || entryDate === undefined || entryDate === '') {
          errors += 1;
        } else if (entryDate && (entryDate < moment(this.schoolStartDate).format('YYYY-MM-DD')
          || entryDate > moment(this.schoolEndDate).format('YYYY-MM-DD'))) {
          errors += 1;
        } else if (entryDate && !this.isValidDateFormat(entryDate, 'YYYY-MM-DD')) {
          errors += 1;
        } else if (exitDate && exitDate > moment(this.schoolEndDate).format('YYYY-MM-DD')) {
          errors += 1;
        } else if (exitDate && !this.isValidDateFormat(exitDate, 'YYYY-MM-DD')) {
          errors += 1;
        } else if (exitDate && exitDate < entryDate) {
          errors += 1;
        }
      });

      if (errors) {
        // tell child components to show their errors if they have any.
        this.hasErrors = true;

        this.messages.push('There were some errors. Please fix the errors highlighted in the fields below.');
        this.showNotification('danger', this.messages);
      } else {
        this.postPrograms();
      }
    },
    async getData() {
      this.loadingMatches = true;
      this.loadingError = false;
      try {
        const response = await Promise.all([
          this.getProgramTypes(),
          this.getMatchResults(),
          this.getManualProgramTypes(),
        ]);
        this.programTypes = response[0].data;
        this.matches = response[1].data.data.sort((a, b) => a.id - b.id);
        this.manualProgramTypes = !this.dmPersonTypeMatching
          ? response[2].data
          : response[2].data.filter(
            p => this.enabledPersonTypes
              .includes(this.student.personType)
              && p.program.personTypeCode === this.student.personType,
          );
        // collect all school codes to a set
        const set = new Set([`${this.student.districtCode},${this.student.schoolCode}`]);
        this.programMatches.flatMap(m => m.studentProgram).forEach((p) => {
          set.add(`${p.districtCode},${p.schoolCode}`);
        });
        set.forEach(async (k) => {
          const codes = k.split(',');
          await this.getSchool({
            districtCode: codes[0],
            schoolCode: codes[1],
          }).then((res) => {
            this.locations.push({ key: k, school: res.data });
          });
        });
      } catch (error) {
        this.loadingError = true;
        const { status } = error.response;
        if (status === 403) {
          this.showNotification('danger', [error.response.data.message]);
        } else {
          this.showNotification('danger', ['No Results Were Found']);
        }
      } finally {
        this.loadingMatches = false;
      }
    },
    locationInfo(type, o) {
      const key = `${o.districtCode},${o.schoolCode}`;
      const d = this.locations.find(loc => key === loc.key);
      if (d) {
        if (type === 'districtId') {
          return d.school.districtLocation.stateLocationId;
        }
        if (type === 'districtName') {
          return d.school.districtLocation.name;
        }
        if (type === 'schoolId') {
          return d.school.location.stateLocationId;
        }
        if (type === 'schoolName') {
          return d.school.location.name;
        }
      }
      return '-';
    },
    getMatchResults() {
      return axios.get(`person/${this.student.stateStudentId}/matches?schoolYear=${this.currentSchoolYear}&manual=true`);
    },
    getProgramTypes() {
      return axios.get('programs?all=true');
    },
    getManualProgramTypes() {
      return axios.get(`matchtypes/${this.manualMatchTypeId}/programs`);
    },
    async getSubmissionSpecs() {
      const temp = await axios.get(`person-types/${this.student.personType}/submission-specs/`);
      this.submissionSpecs.push(temp.data);
    },
    async onLoad() {
      try {
        const promises = [
          this.loadGenders(),
          this.loadMatchTypes(),
          this.loadPersonTypes(),
          this.getSubmissionSpecs(),
        ];
        if (!this.loadingErrorParent && !this.personNotFoundError) {
          promises.push(this.getData());
        }
        await Promise.all(promises);
      } catch (e) {
        this.loadingError = true;
      }
    },
    async postPrograms() {
      try {
        const prunedMatches = this.manualMatches.map(
          ({
            id,
            matchTypeId,
            matchReason,
            matchDate,
            schoolYear,
            studentProgram: {
              programCode,
              districtCode,
              schoolCode,
              entryDate,
              exitDate,
              sourceCode,
              schoolYear: programSchoolYear,
            },
          }) => {
            const o = {
              id,
              matchTypeId,
              matchReason,
              matchDate,
              schoolYear,
              studentProgram: {
                programCode,
                districtCode,
                schoolCode,
                entryDate,
                exitDate,
                sourceCode,
                schoolYear: programSchoolYear,
              },
            };
            return o;
          },
        );
        this.loadingApi = true;
        await axios.post(`person/${this.student.stateStudentId}/matches`, prunedMatches);
        this.hasErrors = false;
        this.refreshMatches();
        this.messages.push('The person program information has been updated successfully.');
        this.showNotification('success', this.messages);
        this.isEditing = false;
      } catch (error) {
        if (error.response) {
          this.messages.push(error.response.data[0].error);
          this.showNotification('danger', this.messages);
        }
      }
      this.loadingApi = false;
    },
    resetErrors() {
      this.hideNotification();
      this.messages = [];
      this.hasErrors = false;
    },
    toggleEdit() {
      this.isEditing = !this.isEditing;
    },
  },
};
</script>
<style lang="sass" scoped>
  .disabled
    color: #999
    cursor: not-allowed
  .match-title
    padding: 1rem 0 1rem
  .table-container
    margin-left: 2rem
    margin-right: 2rem
    margin-top: 1rem !important
  .card-title
    // max-width: 1168px
    padding-bottom: 1rem
    margin-left: 22.5rem
    font-size: 12px
    text-align: left
    font-weight: 700 !important
  .card-title-container
    display: flex
    margin-bottom: 1.5rem
  .column-icons
    display: flex
    align-items: center
  .card-title-icon
    padding-left: 2rem
    padding-right: 1rem
  .document
    // max-width: 1168px
    margin-bottom: 0.5rem !important
    // font-size: .85rem
  .card-container
    padding: .5rem 1rem
  .columns
    margin: 0
    height: 100%
    .column
      display: flex
      align-items: center
      .column-container
        padding-left: 1rem
        padding-right: 1rem
        display: flex
        flex-direction: row
        justify-content: center
        height: 100%
        .block
          display: flex
          flex-direction: column
          justify-content: center
          align-items: flex-start
          text-align: left
          height: 100%
  .student-demographic--columns
    width: 100%
  .student-demographic--headers
    align-items: flex-end !important
    justify-content: space-around
    font-size: 12px
  .student-demographic--details
    align-items: flex-start !important
    justify-content: space-around
  .disabled-icon
    color: #999 !important
    pointer-events: none
  .has-border
    border-left: 1px solid  rgb(222, 226, 230)
  .border--hidden
    border-bottom: hidden
  .fullwidth
    width: 100%
  .half-width
    width: 50%
  .one-fourth-width
    width: 25%
  .marginless
    margin: 0 !important
  .match-type-header
    padding-left: 9px
    border-bottom: 1px solid #dee2e6
</style>
